"use strict";
exports.__esModule = true;
function modifyCSS(dom, css) {
    if (dom) {
        for (var key in css) {
            if (css.hasOwnProperty(key)) {
                dom.style[key] = css[key];
            }
        }
    }
    return dom;
}
exports["default"] = modifyCSS;
//# sourceMappingURL=modify-css.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/dom-util/lib/modify-css.js
// module id = 796
// module chunks = 37